// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__bdol3","what":"what__Y76GK"};


//////////////////
// WEBPACK FOOTER
// ./components/what/style.styl
// module id = YN9x
// module chunks = 0